import { jsx as d, jsxs as g } from "react/jsx-runtime";
import { forwardRef as D, useRef as I, useCallback as R, useEffect as S } from "react";
const A = {
  neutral: {
    selectedBg: "var(--accent-dim)",
    selectedBorder: "var(--accent-border)"
  },
  accent: {
    selectedBg: "var(--accent-dim)",
    selectedBorder: "var(--accent-border)"
  },
  warning: {
    selectedBg: "var(--warning-bg)",
    selectedBorder: "var(--warning-border)"
  }
};
function j({
  value: v,
  onValueChange: i,
  options: n,
  layout: b = "stack",
  name: x,
  "aria-label": m,
  disabled: s = !1,
  className: y
}, h) {
  const o = I([]), p = n.map((e, t) => ({ opt: e, idx: t })).filter(({ opt: e }) => !e.disabled && !s), k = (() => {
    if (v !== null) {
      const e = n.findIndex((t) => t.value === v);
      if (e !== -1 && !n[e]?.disabled) return e;
    }
    return p[0]?.idx ?? -1;
  })(), w = R(
    (e, t) => {
      if (s) return;
      const a = p.map((f) => f.idx);
      if (a.length === 0) return;
      const l = a.indexOf(t);
      let r = l;
      switch (e.key) {
        case "ArrowDown":
        case "ArrowRight":
          e.preventDefault(), r = (l + 1) % a.length;
          break;
        case "ArrowUp":
        case "ArrowLeft":
          e.preventDefault(), r = (l - 1 + a.length) % a.length;
          break;
        case "Home":
          e.preventDefault(), r = 0;
          break;
        case "End":
          e.preventDefault(), r = a.length - 1;
          break;
        case " ":
        case "Enter":
          e.preventDefault();
          {
            const f = n[t];
            f && i(f.value);
          }
          return;
        default:
          return;
      }
      const u = a[r];
      if (u === void 0) return;
      o.current[u]?.focus();
      const c = n[u];
      c && i(c.value);
    },
    [s, p, i, n]
  );
  S(() => {
    o.current = o.current.slice(0, n.length);
  }, [n.length]);
  const B = b === "grid" ? { display: "grid", gridTemplateColumns: "repeat(2, minmax(0, 1fr))", gap: "var(--space-3)" } : { display: "flex", flexDirection: "column", gap: "var(--space-3)" };
  return /* @__PURE__ */ d(
    "div",
    {
      ref: h,
      role: "radiogroup",
      "aria-label": m,
      "aria-disabled": s || void 0,
      "data-name": x,
      className: ["ls-radio-card-group", y].filter(Boolean).join(" "),
      style: B,
      children: n.map((e, t) => {
        const a = e.value === v, l = A[e.tone ?? "neutral"], r = s || e.disabled;
        return /* @__PURE__ */ g(
          "button",
          {
            ref: (c) => {
              o.current[t] = c;
            },
            type: "button",
            role: "radio",
            "aria-checked": a,
            "aria-disabled": r || void 0,
            disabled: r,
            tabIndex: r ? -1 : t === k ? 0 : -1,
            onClick: () => {
              r || i(e.value);
            },
            onKeyDown: (c) => w(c, t),
            className: "ls-focus-ring text-left",
            style: {
              display: "flex",
              flexDirection: "column",
              gap: "var(--space-2)",
              padding: "var(--space-4)",
              background: a ? l.selectedBg : "var(--bg-elevated)",
              border: `1px solid ${a ? l.selectedBorder : "var(--border-default)"}`,
              borderRadius: "var(--radius-xl)",
              color: "var(--text-primary)",
              cursor: r ? "not-allowed" : "pointer",
              opacity: r ? 0.5 : 1,
              transition: "background var(--duration-fast) var(--ease-out), border-color var(--duration-fast) var(--ease-out)",
              fontFamily: "var(--font-sans)"
            },
            "data-radio-card": e.value,
            "data-selected": a || void 0,
            children: [
              /* @__PURE__ */ g(
                "span",
                {
                  style: {
                    display: "flex",
                    alignItems: "flex-start",
                    justifyContent: "space-between",
                    gap: "var(--space-2)"
                  },
                  children: [
                    /* @__PURE__ */ g("span", { style: { display: "flex", alignItems: "center", gap: "var(--space-2)" }, children: [
                      e.icon ? /* @__PURE__ */ d("span", { "aria-hidden": !0, style: { display: "inline-flex" }, children: e.icon }) : null,
                      /* @__PURE__ */ d("span", { style: { fontSize: "var(--text-md)", fontWeight: 600 }, children: e.title })
                    ] }),
                    e.badge ? /* @__PURE__ */ d(
                      "span",
                      {
                        style: {
                          paddingInline: "var(--space-2)",
                          paddingBlock: "var(--space-0_5)",
                          background: "var(--accent-default)",
                          color: "var(--text-on-accent)",
                          borderRadius: "var(--radius-pill)",
                          fontSize: "var(--text-2xs)",
                          fontWeight: 700,
                          letterSpacing: "var(--tracking-uppercase)",
                          textTransform: "uppercase"
                        },
                        children: e.badge
                      }
                    ) : null
                  ]
                }
              ),
              e.media ? /* @__PURE__ */ d("span", { style: { display: "block" }, children: e.media }) : null,
              e.description !== void 0 ? /* @__PURE__ */ d("span", { style: { color: "var(--text-secondary)", fontSize: "var(--text-sm)" }, children: e.description }) : null
            ]
          },
          e.value
        );
      })
    }
  );
}
const C = D(j);
export {
  C as R
};
//# sourceMappingURL=RadioCard-Di2hdIoU.js.map
